// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"80d74050322ecdbad3e8","4362":"5ea27e5c9dd48442fdad"}[chunkId] + ".css";
};